var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSpeakerGreenIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.6248V11.3748H4L9 16.1665V0.833131L4 5.6248H0ZM13.5 8.4998C13.4998 7.69683 13.2657 6.90987 12.824 6.22753C12.3823 5.5452 11.7506 4.99459 11 4.63771V12.3523C12.48 11.6527 13.5 10.196 13.5 8.4998ZM11 0.0952148V2.06938C13.89 2.89355 16 5.46188 16 8.4998C16 11.5377 13.89 14.106 11 14.9302V16.9044C15.01 16.0323 18 12.6015 18 8.4998C18 4.39813 15.01 0.967298 11 0.0952148Z",
    fill: "#0080A3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeakerGreenIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speaker-green-icon.8b76b852.svg";
export { ForwardRef as ReactComponent };